<template>
	<div class="limit-box">
		<div class='flex_center'>
			<div class="line-div"></div>
			<div class="f-s-16">活动太火爆了，明日再来</div>
		</div>
		<div class="flex_center p-15">
			<img src="../../assets/hb.jpg"/>
		</div>
		<div class="flex_center btn-div p-t-20">
			<div class="white f-s-20 w-600 t-c p-t-6">
				今日积分已兑完
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'IntegralLimit',
		data() {
			return {
				agree: false
			}
		},
		props: {
			mobile: {
				type: String,
				default: ''
			}
		},
		methods: {
			doAuto() {
	
			}
		},
	}
</script>

<style scoped>
	.limit-box {
		width: 300px;
		height: max-content;
		padding: 30px 20px;
	}
	
	.line-div {
		width: 5px;
		height: 20px;
		margin-right: 5px;
		background-color: #ee7693;
	}
	
	.btn-div>div {
		width: 250px;
		height: 50px;
		background-image: url(../../assets/bt.jpg);
		background-size: 100% 100%;
	}
	
</style>
